namespace TabAurous.Production {
    export namespace JobWorkIssueItemsService {
        export const baseUrl = 'Production/JobWorkIssueItems';

        export declare function Update(request: Serenity.SaveRequest<JobWorkIssueItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<JobWorkIssueItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<JobWorkIssueItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Update = "Production/JobWorkIssueItems/Update",
            Delete = "Production/JobWorkIssueItems/Delete",
            Retrieve = "Production/JobWorkIssueItems/Retrieve",
            List = "Production/JobWorkIssueItems/List"
        }

        [
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>JobWorkIssueItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
